export default __webpack_public_path__ + "static/media/Evgeniy-Shmarin.3c973a86.png";